/*
 * @Author: your name
 * @Date: 2021-06-24 13:55:19
 * @LastEditTime: 2021-06-25 15:59:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/navigation/vertical/index.js
 */
import Store from '@/store'
import { deepClone } from '@/util/util'

const dynamicRouter = Store.getters.menuAll;
// const { staticRouter } = Store.getters;
// console.log(dynamicRouter, staticRouter, 'data____________')
// const menu = []
// // 自定义菜单格式化方法
// const menuFormat = (data, key = { title: () => 'title', route: 'route', icon: 'icon' }, filter = () => true) => {
//   const dataClone = deepClone(data)
//   dataClone.forEach(item => {
//     if (filter(item)) {
//       // TODO二级菜单代办
//       if (Array.isArray(item.children)) {
//         if (item.children.length > 0) {
//           menu.push(
//             {
//               title: key.title(item),
//               icon: item[key.icon],
//               children: menuFormat(item.children, key, filter),
//             },
//           )
//         }
//       }
//       menu.push(
//         {
//           title: key.title(item),
//           route: item[key.route],
//           icon: item[key.icon],
//         },
//       )
//     }
//   })
// }

// // 静态数据渲染
// // menuFormat(staticRouter, {
// //   title: item => item.meta.pageTitle,
// //   route: 'name',
// //   icon: 'icon',
// // }, item => {
// //   if (item.meta) {
// //     if (item.meta.pageTitle) {
// //       return true
// //     }
// //   }
// //   return false
// // })

// // 动态数据渲染
// menuFormat(dynamicRouter, {
//   title: item => item.name,
//   route: 'code',
//   icon: 'source',
// }, item => item.alias === 'menu')

// console.log(menu, '______________________')
export default dynamicRouter
// [
//   {
//     title: 'Home',
//     route: 'home',
//     icon: 'HomeIcon',
//   },
//   {
//     title: 'Second Page',
//     route: 'second-page',
//     icon: 'FileIcon',
//   },
// ]
